import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Monitor05 = function Monitor05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5.5 20H8m9-11h.01M8 6H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 7.5198 2 8.08 2 9.2v3.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 16 4.08 16 5.2 16H8m7.2 4h3.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 18.4802 22 17.9201 22 16.8V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 4 19.9201 4 18.8 4h-3.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C12 5.5198 12 6.08 12 7.2v9.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218m2.8-5c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1"
    })
  }));
};
export default Monitor05;